import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'client-delete-document-file',
    templateUrl: 'delete-document-file.component.html',
    standalone: false
})
export class ClientDeleteDocumentFileComponent implements OnInit {
	@Input() public model: any;

	@Output() public save = new EventEmitter();
	@Output() public close = new EventEmitter();

	constructor() { }

	public ngOnInit() { }

}
